import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-kri-get-data-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class KriGetDataApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.getKriKpiData"),
            httpMethod: "GET",
            path: "/kri/data/list",

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: {
                        Kri: [
                            {
                                Identfier: "string",
                                Name: "string",
                                Organizations: "string[]",
                            },
                        ],
                    },
                },
            ],
        };
    }
}
